<template>
  <section v-if="isRequestPending"></section>
  <section v-else-if="isRequestFailed">
    Failed to load collection
  </section>
  <yn-with-title v-else-if="collection && collection.length" title="Topics" class="topics container">
    <yn-list
      name="topics"
      :data="collection"
      :total="total"
      :metadata="{
        title: {
          label: 'Title',
          width: '200px'
        },
        description: {
          label: 'Description',
          width: 'minmax(0, 1fr)'
        },
        createdAt: {
          label: 'Created At',
          width: '175px'
        },
        createdBy: {
          label: 'Created By',
          width: '200px'
        }
      }"
      :actions="[{ name: 'delete', label: '&times;', tooltip: 'Delete this item' }]"
      :is-request-pending="isRequestPending"
      :is-request-failed="isRequestFailed"
      @delete="remove"
    >
      <template v-slot:gal>
        <router-link v-if="!isRequestPending" to="/topics/create">+ new topic</router-link>
      </template>
      <template v-slot:title="{ value, item }">
        <router-link :to="{ path: `/topics/${item.id}` }">{{ value }}</router-link>
      </template>
      <template v-slot:createdAt="{ value }">
        {{ new Date(value).toLocaleString() }}
      </template>
    </yn-list>
  </yn-with-title>
  <yn-sample v-else></yn-sample>
</template>

<script>
import { mapState } from 'vuex';

import List from './../common/List';
import Sample from './Sample';
import WithTitle from './../common/_WithTitle';

export default {
  components: {
    'yn-sample': Sample,
    'yn-list': List,
    'yn-with-title': WithTitle
  },
  meta: {
    title: 'Topics'
  },
  data() {
    return {
      isReady: false
    };
  },
  computed: {
    ...mapState({
      currentIdentity: s => s.identity.email,
      collection: s => s.topics.collection,
      total: s => s.topics.total,
      isRequestPending: s => s.topics.isGetCollectionRequestPending,
      isRequestFailed: s => s.topics.isGetCollectionRequestFailed
    })
  },
  async created() {
    await Promise.all([this.$store.dispatch('topics/getCollection')]);
    this.isReady = true;
  },
  methods: {
    async remove({ id }) {
      const lock = this.$lock();
      try {
        await this.$store.dispatch('topics/delete', { id });

        this.$toast.success({
          title: 'Delete completed',
          message: `Topic '${id}' was deleted.`
        });
      } catch (e) {
        this.$toast.error({
          title: 'Delete failed',
          message: `Please, try again later or contact our development team.`
        });
      } finally {
        lock.release();
      }
    }
  }
};
</script>
